import React from 'react'
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote'
import { components } from '../components'
import LegalMdxWrapper from '@package/ds/mdx/legal'
import { WWW_MDX_OVERRIDE_STYLES } from '~/components/molecules/Mdx/styled'

interface Props {
  mdx: MDXRemoteSerializeResult
}

export const LegalMdx: React.VFC<Props> = ({ mdx }) => (
  <LegalMdxWrapper styles={WWW_MDX_OVERRIDE_STYLES}>
    <MDXRemote {...mdx} components={components} />
  </LegalMdxWrapper>
)
